export default __webpack_public_path__ + "static/media/visa.56f4b98d.png";